import { put, takeEvery, all } from 'redux-saga/effects';
import * as constants from '../constants/virtualClass';
import * as virtualClassPageActions from '../actions/virtualClass';
import { SecurityContextType, MessageState } from '../../models/components/announcement.d';
import { Log } from 'ng2-logger';
import { Common } from '../../core/common';
import { VirtualClassService } from '../../api/virtualClass-service';
import { Notification } from '../../components/notification/main';
import * as coreActions from '../actions/core';
import Translator from '../../core/i18n';
import { CacheService } from '../../core/cacheService';
import { IActionRequestDate } from '../../models/core/action-request';

const T = Translator.create();
const _logger = Log.create('VirtualClass Saga');
const _virtualClassService = new VirtualClassService();
const _cacheService = new CacheService();


function* setJoinVirtualClassActivity(params: any) : any {
    try {
        const pageData = yield _virtualClassService.RequestJoinVirtualClassActivityAsync(params).then((responseData: Response) => {
            return responseData;
        }).then((data: any | null) => {
            return data;
        });
        if (pageData) {
            params.callback(pageData);
        }
    } catch (error: any) {
        Notification.setNotification('error', T.t('r_api_virtualclass_url_not_created'), 'topRight');
        yield put(virtualClassPageActions.joinVirtualClassSetAction(null, params.spinnerId, 'set'));
    }
}

function* setRecalculateVirtualClassActivity(params: any) : any {
    try {
        const pageData = yield _virtualClassService.RequestRecalculateVirtualClassActivityAsync(params).then((responseData: Response) => {
            return responseData;
        }).then((data: any) => {
            return data;
        });
        if (pageData) {
            params.callback(pageData);
        }
    } catch (error: any) {
        Notification.setNotification('error', T.t('r_api_virtualclass_url_not_created'), 'topRight');
        yield put(virtualClassPageActions.joinVirtualClassSetAction(null, params.spinnerId, 'set'));
    }
}


const redirectFunction = (params: any, pageData: any) => {
    const redirectPageParams: any = {
        submitValues: params.VirtualClassData,
        activityId: params.VirtualClassData.projectActivityId ? params.VirtualClassData.projectActivityId : params.VirtualClassData.activityId ?? pageData,

        termWeekId:
            params.VirtualClassData.termWeekIds && params.VirtualClassData.termWeekIds[0] !== '0'
                ? params.VirtualClassData.termWeekIds[0]
                : params.VirtualClassData.termWeekIds[1]
    };
    params.callback(redirectPageParams);
}

function* virtualClassAddedSuccessfully(params: any, pageData:any, isError: boolean, unsupportedFileType: any): any {
    if (!isError || unsupportedFileType) {
        yield put(
            coreActions.newNotification(
                params.VirtualClassData.activityId
                    ? T.t('r_update_activity_succesful_notification')
                    : T.t('r_add_activity_succesful_notification'),
                '',
                '',
                'topRight',
                'success'
            )
        );
        redirectFunction(params, pageData);
    }
}

//#region "Add Virtual Class Activity Saga"
function* setAddVirtualClassActivity(params: any) : any {
    let isError = false;
    let errorList: any;
    try {
        const pageData = yield _virtualClassService.RequestAddVirtualClassActivityAsync(params).then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData.json();
        }).then((response) => {
            if (isError) {
                errorList = response;
            } else {
                return response;
            }
        });

        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', params.VirtualClassData.isUpdate ? T.t('r_api_virtual_class_error_edit') : T.t('r_api_virtual_class_error_create') + " " + T.t(errorList[key]), 'topRight');
            });
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
            if (params.callback) {
                params.callback(null);
            }
        }

        let unsupportedFileType = false;
        if(errorList !== undefined)
        {
            Object.keys(errorList).forEach((key: any) => {
                if(errorList[key][0] === 'r_api_unsupported_file_type'){
                    unsupportedFileType = true;
                }
            });
        }
        
        yield virtualClassAddedSuccessfully(params, pageData, isError, unsupportedFileType);

        // tslint:disable-next-line: no-empty
    } catch (error: any) {
        yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        yield put(virtualClassPageActions.addVirtualClassSetAction(null));
        if (params.callback) {
            params.callback(null);
        }
    }
}


// update elesson data!!!
function* setVirtualClassActivity(params: any) : any {
    let isError = false;
    let errorList: any;

    try {
        yield put(virtualClassPageActions.addVirtualClassSetAction(null));
        const pageData = yield _virtualClassService.RequestGetVirtualClassAsync({ ...params, take: 20, skip: 0 })
        .then((response: Response) => {
            return response;
        })
        .then((response: Response) => {
            if (response.status !== 200) {
                isError = true;
            }
            return response.json();
        })
        .then((responseData: any) => {
            if (isError) {
                errorList = responseData;
            } else {
                return responseData;
            }
        })
        .then((data: any | null) => {
            if (!data) {
                return null;
            } else {
                return data;
            }
        });

        if(isError) {
            errorList ? 
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            }) : Notification.setNotification('error', T.t('r_api_gen_update_activity_error'), 'topRight');

            return false;
        } else {
            yield put(virtualClassPageActions.addVirtualClassSetAction(pageData, params.spinnerId, 'set'));
            return true;
        }
    } catch (error: any) {
        Notification.setNotification('error', T.t('r_api_gen_update_activity_error'), 'topRight');
        return false;
    }
}

function* setDeleteVirtualClassActivity(params: any): any {
    try {
        yield _virtualClassService.RequestDeleteVirtualClassActivityAsync(params).then((responseData: Response) => {
            return responseData;
        }).then((data: any | null) => {
            if (data === undefined || data === false) {
                return null;
            } else {
                return data;
            }
        });

        yield put(virtualClassPageActions.addVirtualClassSetAction(null));
        // tslint:disable-next-line: no-empty
    } catch (error: any) {

    }
}

function* getMyVirtualClass(params: any): any {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        yield _virtualClassService.RequestGetMyAsync(params.Filters).then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData.json();
        }).then((response) => {
            if (isError) {
                errorList = response;
            } else {
                pageData = response;
            }
        });

        if (isError) {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : Notification.setNotification('error', T.t('r_virtual_class_page_my_error_message'), 'topRight');
        }
        if (!isError) {
            yield put(virtualClassPageActions.getMyVirtualClassSetAction(pageData, params.spinnerId, 'set'));
        }
    } catch (error: any) {
        Notification.setNotification('error', T.t('r_virtual_class_page_my_error_message'), 'topRight');
    }
}

export function* watchGetAddVirtualClassData() {
    yield takeEvery(constants.actions.ADD_VIRTUALCLASS_ACTIVITY, setAddVirtualClassActivity);
    return null;
}

export function* watchGetDeleteVirtualClassData() {
    yield takeEvery(constants.actions.DELETE_VIRTUALCLASS_ACTIVITY, setDeleteVirtualClassActivity);
    return null;
}

export function* watchUpdateVirtualClassData() {
    yield takeEvery(constants.actions.ADD_VIRTUALCLASS_UPDATE_ACTIVITY, setVirtualClassActivity);
    return null;
}

export function* watchJoinVirtualClassData() {
    yield takeEvery(constants.actions.JOIN_VIRTUALCLASS_ACTIVITY, setJoinVirtualClassActivity);
    return null;
}

export function* watchRecalculateVirtualClassData() {
    yield takeEvery(constants.actions.RECALCULATE_VIRTUALCLASS_ACTIVITY, setRecalculateVirtualClassActivity);
    return null;
}

export function* watchGetMyVirtualClass() {
    yield takeEvery(constants.actions.GET_MY, getMyVirtualClass);
}

//#endregion "Add Virtual Class Activity End Saga"

export function* VirtualClassSagas() {
    yield all([
        watchGetAddVirtualClassData(),
        watchGetDeleteVirtualClassData(),
        watchUpdateVirtualClassData(),
        watchJoinVirtualClassData(),
        watchGetMyVirtualClass(),
        watchRecalculateVirtualClassData(),
    ]);
}
